import React from 'react';
import ProgressiveImage from 'react-progressive-image';

class ThumbSlide extends React.PureComponent {
  render() {
    const { slider, project, index } = this.props;
    const { title, original, tiny } = project;
    const isActive = slider.state.currentPage ? slider.state.currentPage : 0;
    return (
      <div>
        <div
          role="presentation"
          className="project_slide__link"
          onClick={() => {
            if (slider.slider) {
              slider.gotoSlideIndex(index);
            }
          }}
        >
          {
            <ProgressiveImage src={original} placeholder={tiny}>
              {(src, loading) => (
                <div style={{ opacity: loading ? 0.5 : 1 }}>
                  <img
                    className={`project_slide__image project_slide__thumb ${
                      isActive === index ? ' project_slide__thumb--active' : ''
                    }`}
                    src={src}
                    alt={title}
                  />
                </div>
              )}
            </ProgressiveImage>

            // <img
            // className={
            //   "project_slide__image project_slide__thumb " +
            //   (isActive === this.props.index
            //     ? " project_slide__thumb--active"
            //     : "")
            // }
            //   src={original}
            //   alt={title}
            // />
          }
        </div>
      </div>
    );
  }
}
export default ThumbSlide;



// WEBPACK FOOTER //
// ./src/components/Sliders/ThumbSlide.js